"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28294],{

/***/ 63471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/_next/static/media/beach-house-interior-1.bc69273a536a51bb58092b2896b92e3a.jpg");

/***/ }),

/***/ 99996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/_next/static/media/air-jordan-1-mid-se-shoes-hHltxp.025788e39d6a5ef36ad2cec2b7cdd8dc.jpeg");

/***/ }),

/***/ 28294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradly_home_EnablingEntrepreneurs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Widont.js
var Widont = __webpack_require__(15253);
// EXTERNAL MODULE: ./src/components/home/common.js
var common = __webpack_require__(47262);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.esm.js
var tabs_esm = __webpack_require__(66311);
;// CONCATENATED MODULE: ./src/img/tradly/hero_icons/creators1.svg
var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgCreators1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#8C9EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.286 11H11.823a.824.824 0 00-.823.823v11.53c0 .455.369.823.823.823h26.463a.824.824 0 00.824-.823v-11.53a.824.824 0 00-.824-.823z",
    fill: "#FFDA2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.11 11.823v11.53a.824.824 0 01-.824.823H25.055V11h13.231c.455 0 .824.369.824.823z",
    fill: "#FDBF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.059 25.823h-8.236a.824.824 0 00-.823.824v11.53c0 .454.369.823.823.823h8.236a.824.824 0 00.823-.824v-11.53a.824.824 0 00-.823-.823z",
    fill: "#0097F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.286 25.823H23.353a.824.824 0 00-.824.824v11.53c0 .454.369.823.824.823h14.933a.824.824 0 00.824-.824v-11.53a.824.824 0 00-.824-.823z",
    fill: "#0052C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.11 26.647v11.53a.824.824 0 01-.824.823H25.055V25.823h13.231c.455 0 .824.37.824.824z",
    fill: "#003481"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.273 28.261l1.175-.984a.824.824 0 00-.167-1.37l-8.96-4.383a.824.824 0 00-1.16.944l2.512 9.79a.824.824 0 001.326.426l1.172-.982 1.248 1.496a.824.824 0 001.162.104l2.84-2.383a.823.823 0 00.103-1.159l-1.25-1.499z",
    fill: "#FF641A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.524 29.76a.824.824 0 01-.103 1.159l-1.19 1-8.777-10.304a.809.809 0 01.866-.091l8.961 4.382a.824.824 0 01.167 1.372l-1.174.984 1.25 1.498z",
    fill: "#F03800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.765 14.294a2.474 2.474 0 00-2.471 2.47v3.295a.824.824 0 001.647 0v-.824h1.647v.824a.824.824 0 001.647 0v-3.294a2.473 2.473 0 00-2.47-2.471zm-.824 3.294v-.823a.824.824 0 011.647 0v.823h-1.647zM22.53 14.294h-.824a.824.824 0 00-.824.823v4.942c0 .454.369.823.824.823h.823a3.298 3.298 0 003.294-3.294 3.298 3.298 0 00-3.294-3.294zm0 4.941v-3.294c.908 0 1.646.739 1.646 1.647s-.738 1.647-1.647 1.647z",
    fill: "#FE9022"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.055 15.476V19.7c.48-.572.769-1.31.769-2.112 0-.804-.289-1.54-.769-2.112zM28.294 16.49h6.588a.824.824 0 000-1.647h-6.588a.824.824 0 000 1.647zM34.883 18.137h-6.589a.824.824 0 000 1.647h6.588a.824.824 0 000-1.647z",
    fill: "#FF641A"
  })));
}
/* harmony default export */ var creators1 = ("/_next/static/media/creators1.1924a173ec848126dfad64f122ac8c6d.svg");

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/feature.js
var feature = __webpack_require__(6597);
// EXTERNAL MODULE: ./node_modules/react-color/es/index.js + 218 modules
var es = __webpack_require__(30780);
// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/CheckoutPageLayout.jsx + 9 modules
var CheckoutPageLayout = __webpack_require__(15024);
// EXTERNAL MODULE: ./src/css/tradly_css.json
var tradly_css = __webpack_require__(10386);
// EXTERNAL MODULE: ./node_modules/react-outside-click-handler/index.js
var react_outside_click_handler = __webpack_require__(39834);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/data/CheckoutPageData.js
var CheckoutPageData = __webpack_require__(49965);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/NocodeCheckout.jsx





var NocodeCheckout = function(param) {
    var showStock = param.showStock, showShippingCharge = param.showShippingCharge, showQuantityTextBox = param.showQuantityTextBox, showShippingMethod = param.showShippingMethod;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,react.useState)(null), paymentMethod = ref6[0], setPaymentMethod = ref6[1];
    var ref7 = (0,react.useState)(null), shippingMethod = ref7[0], setShippingMethod = ref7[1];
    var ref8 = (0,react.useState)(false), showError = ref8[0], setShowError = ref8[1];
    var ref9 = (0,react.useState)(""), error_message = ref9[0], setError_message = ref9[1];
    var ref10 = (0,react.useState)(false), showShippingAddressForm = ref10[0], setShowShippingAddressForm = ref10[1];
    var ref11 = (0,react.useState)(null), selectShippingAddress = ref11[0], setSelectShippingAddress = ref11[1];
    var ref12 = (0,react.useState)(false), isNewAddress = ref12[0], setIsNewAddress = ref12[1];
    var ref13 = (0,react.useState)(null), selectStorageHubAddress = ref13[0], setSelectStorageHubAddress = ref13[1];
    var ref14 = (0,react.useState)(false), showSuccessMessage = ref14[0], setShowSuccessMessage = ref14[1];
    var ref15 = (0,react.useState)(1), count = ref15[0], setCount = ref15[1];
    var selectShippingMethod = function(method) {
        setShippingMethod(method);
    };
    var selectPaymentMethod = function(method) {
        setPaymentMethod(method);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " mx-auto w-full grid gap-4 p-5 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " ",
                    children: [
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-[#FEFEFE] rounded-lg shadow-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: CheckoutPageData.cart_details.map(function(cartItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: " w-full border border-d_primary rounded-lg px-[24px] py-[16px] grid grid-cols-[100%] justify-between mb-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    showStock && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: " text-xs font-semibold leading-6 text-d_primary",
                                                        children: [
                                                            cartItem.listing.stock,
                                                            " products in stock"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: " text-base text-black font-semibold mt-[2px]",
                                                        children: cartItem.listing.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: " mt-[11px] text-secondary text-xs font-medium flex flex-wrap items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: " text-xs leading-6 font-medium text-secondary mr-2",
                                                                children: cartItem.listing.list_price.currency
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-sm ",
                                                                children: cartItem.listing.list_price.amount
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: " w-full mt-6 flex items-center justify-around",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: " min-w-[90px] h-[32px] border border-d_primary rounded-[2px] flex justify-between items-center ",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                onClick: function() {
                                                                    return count > 1 && setCount(count - 1);
                                                                },
                                                                className: " w-[32px] h-[32px] bg-d_primary rounded-l-sm flex justify-center items-center text-xl leading-6 font-medium text-white",
                                                                children: "-"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: " text-sm leading-4 font-medium text-[#4A4A4A] mx-3",
                                                                children: count
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                onClick: function() {
                                                                    return setCount(count + 1);
                                                                },
                                                                className: "w-[32px] h-[32px] bg-d_primary rounded-r-sm flex justify-center items-center text-xl leading-6 font-medium text-white ",
                                                                children: "+"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "w-[32px] h-[32px] bg-d_primary flex justify-center items-center text-xl leading-6 font-medium text-white rounded",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                className: "h-6 w-6",
                                                                fill: "none",
                                                                viewBox: "0 0 24 24",
                                                                stroke: "currentColor",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round",
                                                                    strokeWidth: "2",
                                                                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, cartItem.id);
                                })
                            })
                        }),
                        showShippingMethod && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " w-full min-h-[100px] bg-[#FEFEFE] rounded-lg p-5 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-d_primary text-xl leading-6 font-medium ",
                                        children: "Shipping Method"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " mt-5 flex items-center flex-wrap",
                                        children: CheckoutPageData.shipping_methods.map(function(method) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: (shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.id) !== method.id ? " min-w-[100px] h-5 px-2   inset-0 py-4 border border-secondary flex items-center justify-between rounded-lg mr-3 mb-3 transition duration-700   hover:border-d_primary hover:text-d_primary" : " min-w-[100px] h-5 px-2   py-4 border   flex items-center justify-between rounded-lg mr-3 mb-3    border-transparent bg-d_primary text-white  cursor-pointer  ring-2 ring-d_primary ring-offset-2 ",
                                                onClick: function() {
                                                    return selectShippingMethod(method);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: " text-sm font-semibold mr-3",
                                                        children: method.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-5 w-5 ml-3",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "2",
                                                            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                        })
                                                    })
                                                ]
                                            }, method.id);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " w-full bg-[#FEFEFE] rounded-lg p-5 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-d_primary text-xl leading-6 font-medium ",
                                        children: "Payment Method"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " mt-5 flex items-center flex-wrap",
                                        children: CheckoutPageData.payment_methods === null || CheckoutPageData.payment_methods === void 0 ? void 0 : CheckoutPageData.payment_methods.map(function(method) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id) !== method.id ? " min-w-[100px] h-5 px-2  py-4 border border-secondary flex items-center justify-between rounded-lg mr-3 mb-3  transition duration-700    hover:border-d_primary hover:text-d_primary" : " min-w-[100px] h-5 px-2 px-6 py-4 border   flex items-center justify-between   mr-3 mb-3  border-transparent bg-d_primary text-white rounded-md cursor-pointer  ring-2 ring-d_primary ring-offset-2 ",
                                                onClick: function() {
                                                    return selectPaymentMethod(method);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: " text-sm font-semibold mr-3",
                                                        children: method.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-5 w-5 ml-3",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "2",
                                                            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                        })
                                                    })
                                                ]
                                            }, method.id);
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " shadow-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " w-full min-h-[200px] bg-[#FEFEFE] rounded-lg py-[26px] px-6 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-d_primary text-xl leading-6 font-medium mt-3",
                                    children: "Order Summary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-5",
                                    children: CheckoutPageData.cart_details === null || CheckoutPageData.cart_details === void 0 ? void 0 : CheckoutPageData.cart_details.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full bg-[#FFFFFF] rounded-lg shadow-c-sm overflow-hidden flex mb-3 ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " w-[100px] h-[100px] relative mr-3 bg-gray",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: item.listing.images[0],
                                                        layout: "fill",
                                                        objectFit: "cover",
                                                        alt: "Order Items",
                                                        priority: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: " flex flex-col justify-around py-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: " text-base font-semibold text-black",
                                                                children: item.listing.title
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: " text-base font-medium text-secondary ",
                                                                    children: item.listing.location.country
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: " text-base font-medium text-secondary ",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "Quantity :"
                                                                        }),
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: item.quantity
                                                                        }),
                                                                        " "
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, item.id);
                                    })
                                }),
                                showQuantityTextBox && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8",
                                    children: CheckoutPageData.cart_details.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " w-full min-h-[57px] bg-[#FFFFFF] border border-d_primary rounded-lg px-4 py-5 mb-3 ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: " text-sm leading-4 font-semibold text-[#4F4F4F] ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: item.quantity
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ml-2",
                                                        children: "X"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ml-2",
                                                        children: item.listing.title
                                                    })
                                                ]
                                            })
                                        }, item.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-base leading-6 font-semibold text-secondary flex justify-between items-center mb-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Total"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: " flex flex-wrap items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-sm leading-6 font-medium text-secondary mr-2",
                                                            children: (ref = CheckoutPageData.cart.list_total) === null || ref === void 0 ? void 0 : ref.currency
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-base leading-6 font-semibold text-gray-600",
                                                            children: (ref1 = CheckoutPageData.cart.list_total) === null || ref1 === void 0 ? void 0 : ref1.amount
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        showShippingCharge && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-base leading-6 font-semibold text-secondary flex justify-between items-center mb-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Shipping"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: " flex flex-wrap items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-sm leading-6 font-medium text-secondary mr-2",
                                                            children: (ref2 = CheckoutPageData.cart.shipping_total) === null || ref2 === void 0 ? void 0 : ref2.currency
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-base leading-6 font-semibold text-gray-600",
                                                            children: (ref3 = CheckoutPageData.cart.shipping_total) === null || ref3 === void 0 ? void 0 : ref3.amount
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-xl leading-6 font-semibold text-black flex justify-between items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Subtotal"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: " flex flex-wrap items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-sm leading-6 font-medium text-secondary mr-2",
                                                            children: (ref4 = CheckoutPageData.cart.grand_total) === null || ref4 === void 0 ? void 0 : ref4.currency
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-xl leading-6 font-semibold text-black",
                                                            children: (ref5 = CheckoutPageData.cart.grand_total) === null || ref5 === void 0 ? void 0 : ref5.amount
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: " w-5/6 bg-d_primary rounded-full py-[12px] text-center text-base text-white flex justify-center items-center font-semibold",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: " ",
                                    children: "Checkout"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CheckoutPage_NocodeCheckout = (NocodeCheckout);

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/common.module.scss
var common_module = __webpack_require__(27087);
var common_module_default = /*#__PURE__*/__webpack_require__.n(common_module);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/StylingFeature.js








var StylingFeature = function() {
    var ref = (0,react.useState)("#01544E"), colorCode = ref[0], setColorCode = ref[1];
    (0,react.useEffect)(function() {
        if (true) {
            var root = document.documentElement;
            root.style.setProperty("--d_color-primary", colorCode);
        }
    }, [
        colorCode
    ]);
    var handleChangeComplete = function(color) {
        setColorCode(color.hex);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (common_module_default()).bg_style,
        style: {
            paddingTop: "20px",
            paddingBottom: "20px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid md:grid-cols-2 gap-3 max-h-[600px] md:max-h-[410px] overflow-hidden px-5 md:px-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: " text-bse font-semibold text-black mb-2 ",
                            children: "Select Primary Color"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "flex items-center border border-d_primary h-8 gap-4 rounded-md overflow-hidden ml-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-sm text-d_primary ml-2",
                                    children: colorCode
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "w-[70px] h-full  bg-d_primary block"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "block   top-0  mt-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TwitterPicker */.e8, {
                                color: colorCode,
                                onChangeComplete: function(color) {
                                    return handleChangeComplete(color);
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-h-[400px] overflow-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutPage_NocodeCheckout, {
                        showStock: true,
                        showShippingCharge: true,
                        showQuantityTextBox: true,
                        showShippingMethod: true
                    })
                })
            ]
        })
    });
};
var StylingFeatureComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StylingFeature, {})
    });
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/switch/switch.esm.js + 1 modules
var switch_esm = __webpack_require__(86354);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/Features.js









var Features = function() {
    var ref = (0,react.useState)(true), showStock = ref[0], setShowStock = ref[1];
    var ref1 = (0,react.useState)(true), showShippingCharge = ref1[0], setShowShippingCharge = ref1[1];
    var ref2 = (0,react.useState)(true), showShippingMethod = ref2[0], setShowShippingMethod = ref2[1];
    var ref3 = (0,react.useState)(true), showQuantityTextBox = ref3[0], setShowQuantityTextBox = ref3[1];
    (0,react.useEffect)(function() {
        if (true) {
            var root = document.documentElement;
            root.style.setProperty("--d_color-primary", "#01544E");
        }
    }, [
        0
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (common_module_default()).bg_style,
        style: {
            paddingTop: "20px",
            paddingBottom: "20px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid md:grid-cols-2 gap-4 max-h-[600px] md:max-h-[410px] overflow-hidden px-5 md:px-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative bg-white p-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: " text-base font-semibold text-black ",
                                    children: "Enable stock"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(switch_esm/* Switch */.r, {
                                    checked: showStock,
                                    onChange: function() {
                                        return setShowStock(!showStock);
                                    },
                                    className: "".concat(showStock ? "bg-primary" : "bg-gray-400", "\n          relative inline-flex flex-shrink-0 h-[20px] w-[42px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75"),
                                    children: [
                                        showStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-4 w-4 absolute left-[2px] top-0 bottom-0 my-auto text-bold text-white ",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                                "clip-rule": "evenodd"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-4 w-4 absolute right-[2px] top-0 bottom-0 my-auto text-bold text-white ",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                "clip-rule": "evenodd"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Use setting"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-hidden": "true",
                                            className: "".concat(showStock ? "translate-x-[21px] bg-white" : "translate-x-0", "\n            pointer-events-none inline-block h-[16px] w-[16px] rounded-full  shadow-lg bg-white transform ring-0 transition ease-in-out duration-200")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-4 mt-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: " text-base font-semibold text-black ",
                                    children: "Enable shipping method"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(switch_esm/* Switch */.r, {
                                    checked: showShippingMethod,
                                    onChange: function() {
                                        return setShowShippingMethod(!showShippingMethod);
                                    },
                                    className: "".concat(showShippingMethod ? "bg-primary" : "bg-gray-400", "\n          relative inline-flex flex-shrink-0 h-[20px] w-[42px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75"),
                                    children: [
                                        showShippingMethod ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-4 w-4 absolute left-[2px] top-0 bottom-0 my-auto text-bold text-white ",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                                "clip-rule": "evenodd"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-4 w-4 absolute right-[2px] top-0 bottom-0 my-auto text-bold text-white ",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                "clip-rule": "evenodd"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Use setting"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-hidden": "true",
                                            className: "".concat(showShippingMethod ? "translate-x-[21px] bg-white" : "translate-x-0", "\n            pointer-events-none inline-block h-[16px] w-[16px] rounded-full  shadow-lg bg-white transform ring-0 transition ease-in-out duration-200")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-4 mt-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: " text-base font-semibold text-black ",
                                    children: "Enable shipping charge"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(switch_esm/* Switch */.r, {
                                    checked: showShippingCharge,
                                    onChange: function() {
                                        return setShowShippingCharge(!showShippingCharge);
                                    },
                                    className: "".concat(showShippingCharge ? "bg-primary" : "bg-gray-400", "\n          relative inline-flex flex-shrink-0 h-[20px] w-[42px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75"),
                                    children: [
                                        showShippingCharge ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-4 w-4 absolute left-[2px] top-0 bottom-0 my-auto text-bold text-white ",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                                "clip-rule": "evenodd"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-4 w-4 absolute right-[2px] top-0 bottom-0 my-auto text-bold text-white ",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                "clip-rule": "evenodd"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Use setting"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-hidden": "true",
                                            className: "".concat(showShippingCharge ? "translate-x-[21px] bg-white" : "translate-x-0", "\n            pointer-events-none inline-block h-[16px] w-[16px] rounded-full  shadow-lg bg-white transform ring-0 transition ease-in-out duration-200")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-h-[400px] overflow-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutPage_NocodeCheckout, {
                        showStock: showStock,
                        showShippingCharge: showShippingCharge,
                        showQuantityTextBox: showQuantityTextBox,
                        showShippingMethod: showShippingMethod
                    })
                })
            ]
        })
    });
};
var FeaturesComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {})
    });
};

;// CONCATENATED MODULE: ./src/components/home/tradly-home/EnablingEntrepreneurs.jsx










function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var EnablingEntrepreneurs = function() {
    var categories = [
        {
            id: 1,
            buttonTitle: "Styling",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.4199 15.54C7.23365 15.7274 7.12911 15.9808 7.12911 16.245C7.12911 16.5092 7.23365 16.7627 7.4199 16.95C7.51286 17.0437 7.62346 17.1181 7.74532 17.1689C7.86718 17.2197 7.99789 17.2458 8.1299 17.2458C8.26191 17.2458 8.39262 17.2197 8.51448 17.1689C8.63633 17.1181 8.74694 17.0437 8.8399 16.95C9.02615 16.7627 9.13069 16.5092 9.13069 16.245C9.13069 15.9808 9.02615 15.7274 8.8399 15.54C8.74694 15.4463 8.63633 15.3719 8.51448 15.3211C8.39262 15.2704 8.26191 15.2442 8.1299 15.2442C7.99789 15.2442 7.86718 15.2704 7.74532 15.3211C7.62346 15.3719 7.51286 15.4463 7.4199 15.54ZM7.4199 7.05002C7.23365 7.23738 7.12911 7.49083 7.12911 7.75502C7.12911 8.0192 7.23365 8.27265 7.4199 8.46002C7.51286 8.55375 7.62346 8.62814 7.74532 8.67891C7.86718 8.72968 7.99789 8.75582 8.1299 8.75582C8.26191 8.75582 8.39262 8.72968 8.51448 8.67891C8.63633 8.62814 8.74694 8.55375 8.8399 8.46002C9.02615 8.27265 9.13069 8.0192 9.13069 7.75502C9.13069 7.49083 9.02615 7.23738 8.8399 7.05002C8.74694 6.95629 8.63633 6.88189 8.51448 6.83113C8.39262 6.78036 8.26191 6.75422 8.1299 6.75422C7.99789 6.75422 7.86718 6.78036 7.74532 6.83113C7.62346 6.88189 7.51286 6.95629 7.4199 7.05002ZM12.3699 17.05C12.1721 17.05 11.9788 17.1087 11.8143 17.2185C11.6499 17.3284 11.5217 17.4846 11.446 17.6673C11.3703 17.8501 11.3505 18.0511 11.3891 18.2451C11.4277 18.4391 11.5229 18.6173 11.6628 18.7571C11.8026 18.897 11.9808 18.9922 12.1748 19.0308C12.3688 19.0694 12.5699 19.0496 12.7526 18.9739C12.9353 18.8982 13.0915 18.77 13.2014 18.6056C13.3112 18.4411 13.3699 18.2478 13.3699 18.05C13.3767 17.9145 13.3558 17.7791 13.3086 17.652C13.2614 17.5248 13.1888 17.4086 13.0953 17.3104C13.0017 17.2121 12.8892 17.134 12.7645 17.0806C12.6398 17.0273 12.5055 16.9998 12.3699 17V17.05ZM6.3699 11.05C6.17212 11.05 5.97878 11.1087 5.81433 11.2185C5.64988 11.3284 5.52171 11.4846 5.44602 11.6673C5.37033 11.8501 5.35053 12.0511 5.38911 12.2451C5.4277 12.4391 5.52294 12.6173 5.66279 12.7571C5.80264 12.897 5.98083 12.9922 6.17481 13.0308C6.36879 13.0694 6.56986 13.0496 6.75258 12.9739C6.93531 12.8982 7.09149 12.77 7.20137 12.6056C7.31125 12.4411 7.3699 12.2478 7.3699 12.05C7.37668 11.9145 7.35583 11.7791 7.30862 11.652C7.26141 11.5248 7.18883 11.4086 7.09529 11.3104C7.00174 11.2121 6.8892 11.134 6.76449 11.0806C6.63979 11.0273 6.50554 10.9998 6.3699 11V11.05ZM12.3699 5.05002C12.1721 5.05002 11.9788 5.10867 11.8143 5.21855C11.6499 5.32843 11.5217 5.48461 11.446 5.66733C11.3703 5.85006 11.3505 6.05113 11.3891 6.24511C11.4277 6.43909 11.5229 6.61727 11.6628 6.75712C11.8026 6.89698 11.9808 6.99222 12.1748 7.0308C12.3688 7.06939 12.5699 7.04958 12.7526 6.9739C12.9353 6.89821 13.0915 6.77004 13.2014 6.60559C13.3112 6.44114 13.3699 6.2478 13.3699 6.05002C13.3767 5.91455 13.3558 5.77912 13.3086 5.65196C13.2614 5.5248 13.1888 5.40858 13.0953 5.31036C13.0017 5.21214 12.8892 5.13398 12.7645 5.08062C12.6398 5.02727 12.5055 4.99985 12.3699 5.00002V5.05002ZM15.9099 7.10002C15.7695 7.23963 15.6736 7.4178 15.6346 7.61195C15.5955 7.80609 15.6149 8.00746 15.6905 8.19053C15.766 8.37361 15.8941 8.53014 16.0587 8.64028C16.2233 8.75042 16.4169 8.80922 16.6149 8.80922C16.8129 8.80922 17.0065 8.75042 17.1711 8.64028C17.3357 8.53014 17.4638 8.37361 17.5393 8.19053C17.6149 8.00746 17.6343 7.80609 17.5952 7.61195C17.5562 7.4178 17.4603 7.23963 17.3199 7.10002C17.1392 6.90697 16.8895 6.79334 16.6252 6.78397C16.361 6.7746 16.1038 6.87025 15.9099 7.05002V7.10002ZM22.2099 7.10002C21.2956 5.27231 19.8903 3.73544 18.1515 2.66172C16.4127 1.588 14.4091 1.0199 12.3655 1.02112C10.3219 1.02234 8.31902 1.59284 6.58148 2.66863C4.84395 3.74443 3.44045 5.28298 2.52838 7.11178C1.61631 8.94057 1.23172 10.9873 1.41774 13.0224C1.60377 15.0576 2.35305 17.0006 3.58157 18.6338C4.81008 20.2669 6.46926 21.5255 8.37304 22.2684C10.2768 23.0114 12.3499 23.2093 14.3599 22.84C14.8653 22.7449 15.3468 22.55 15.776 22.2667C16.2053 21.9834 16.5737 21.6174 16.8599 21.19C17.1682 20.7254 17.381 20.2041 17.4857 19.6564C17.5905 19.1087 17.5851 18.5456 17.4699 18C17.4069 17.6703 17.3735 17.3357 17.3699 17C17.3743 16.031 17.6602 15.0841 18.1928 14.2745C18.7254 13.465 19.4817 12.8276 20.3699 12.44C20.8488 12.2256 21.2786 11.9153 21.6329 11.5284C21.9872 11.1414 22.2585 10.6859 22.4299 10.19C22.6033 9.6833 22.6732 9.14693 22.6354 8.6127C22.5976 8.07847 22.4529 7.55728 22.2099 7.08002V7.10002ZM20.5099 9.54002C20.4246 9.77933 20.2921 9.99911 20.1203 10.1863C19.9486 10.3736 19.741 10.5244 19.5099 10.63C18.2799 11.1806 17.2349 12.0746 16.5006 13.2045C15.7662 14.3345 15.3736 15.6524 15.3699 17C15.3714 17.4701 15.4183 17.9389 15.5099 18.4C15.571 18.6818 15.575 18.973 15.5218 19.2564C15.4685 19.5397 15.3591 19.8096 15.1999 20.05C15.0652 20.2604 14.888 20.4403 14.6796 20.5781C14.4712 20.7159 14.2362 20.8085 13.9899 20.85C13.4558 20.9504 12.9134 21.0006 12.3699 21C11.1641 21.0006 9.97041 20.7589 8.85982 20.2892C7.74923 19.8195 6.74435 19.1314 5.90486 18.2658C5.06537 17.4002 4.40838 16.3747 3.97291 15.2502C3.53745 14.1258 3.33238 12.9253 3.3699 11.72C3.44751 9.47281 4.3589 7.33497 5.92653 5.72298C7.49415 4.11099 9.60573 3.1403 11.8499 3.00002H12.3599C14.0357 3.00044 15.678 3.4687 17.102 4.35208C18.526 5.23546 19.6751 6.49887 20.4199 8.00002C20.6491 8.475 20.6815 9.0213 20.5099 9.52002V9.54002ZM12.3699 11C12.1721 11 11.9788 11.0587 11.8143 11.1685C11.6499 11.2784 11.5217 11.4346 11.446 11.6173C11.3703 11.8001 11.3505 12.0011 11.3891 12.1951C11.4277 12.3891 11.5229 12.5673 11.6628 12.7071C11.8026 12.847 11.9808 12.9422 12.1748 12.9808C12.3688 13.0194 12.5699 12.9996 12.7526 12.9239C12.9353 12.8482 13.0915 12.72 13.2014 12.5556C13.3112 12.3911 13.3699 12.1978 13.3699 12C13.3699 11.7348 13.2645 11.4804 13.077 11.2929C12.8895 11.1054 12.6351 11 12.3699 11Z"
            }),
            feature: StylingFeatureComponent
        },
        {
            id: 2,
            buttonTitle: "Features",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 8.5C15.3078 8.5 14.6311 8.70527 14.0555 9.08986C13.4799 9.47444 13.0313 10.0211 12.7664 10.6606C12.5015 11.3001 12.4322 12.0039 12.5673 12.6828C12.7023 13.3617 13.0356 13.9854 13.5251 14.4749C14.0146 14.9644 14.6383 15.2977 15.3172 15.4327C15.9961 15.5678 16.6999 15.4985 17.3394 15.2336C17.9789 14.9687 18.5256 14.5201 18.9101 13.9445C19.2947 13.3689 19.5 12.6922 19.5 12C19.5 11.0717 19.1313 10.1815 18.4749 9.52513C17.8185 8.86875 16.9283 8.5 16 8.5ZM16 13.5C15.7033 13.5 15.4133 13.412 15.1666 13.2472C14.92 13.0824 14.7277 12.8481 14.6142 12.574C14.5006 12.2999 14.4709 11.9983 14.5288 11.7074C14.5867 11.4164 14.7296 11.1491 14.9393 10.9393C15.1491 10.7296 15.4164 10.5867 15.7074 10.5288C15.9983 10.4709 16.2999 10.5006 16.574 10.6142C16.8481 10.7277 17.0824 10.92 17.2472 11.1666C17.412 11.4133 17.5 11.7033 17.5 12C17.5 12.3978 17.342 12.7794 17.0607 13.0607C16.7794 13.342 16.3978 13.5 16 13.5ZM16 5H8C6.14348 5 4.36301 5.7375 3.05025 7.05025C1.7375 8.36301 1 10.1435 1 12C1 13.8565 1.7375 15.637 3.05025 16.9497C4.36301 18.2625 6.14348 19 8 19H16C17.8565 19 19.637 18.2625 20.9497 16.9497C22.2625 15.637 23 13.8565 23 12C23 10.1435 22.2625 8.36301 20.9497 7.05025C19.637 5.7375 17.8565 5 16 5ZM16 17H8C6.67392 17 5.40215 16.4732 4.46447 15.5355C3.52678 14.5979 3 13.3261 3 12C3 10.6739 3.52678 9.40215 4.46447 8.46447C5.40215 7.52678 6.67392 7 8 7H16C17.3261 7 18.5979 7.52678 19.5355 8.46447C20.4732 9.40215 21 10.6739 21 12C21 13.3261 20.4732 14.5979 19.5355 15.5355C18.5979 16.4732 17.3261 17 16 17Z"
            }),
            feature: FeaturesComponent
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: creators1,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Caption */.YS, {
                className: "text-color1",
                children: "Enabling Entrepreneurs and Creators"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* BigText */.y8, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Widont/* Widont */.X, {
                    children: "Easy to use no-code tools"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Paragraph */.nv, {
                children: "When starting out, speed to market is crucial. Our no-code solution ensures complete customization. Begin with 100% customizable pre-built templates. As you grow, tailor the CSS or add new blocks for dynamic or static content."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full sm:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab.Group */.O.Group, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.List */.O.List, {
                            className: "mt-2 flex p-1 items-center gap-7 ",
                            children: categories.map(function(category) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab */.O, {
                                    className: function(param) {
                                        var selected = param.selected;
                                        return classNames("w-[96px] py-2.5 text-sm leading-5 font-medium rounded-lg flex flex-col justify-center items-center gap-6  group outline-none", selected ? " transition duration-500 text-color1" : "text-gray-300  hover:text-gray-400");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-12 w-12",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: category.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: " ",
                                            children: category.buttonTitle
                                        })
                                    ]
                                }, category);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panels */.O.Panels, {
                            className: "pt-10 xl:pt-0 xl:mt-2",
                            children: categories.map(function(post, idx) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panel */.O.Panel, {
                                    className: classNames("bg-white rounded-xl  ", "focus:outline-none    "),
                                    children: post === null || post === void 0 ? void 0 : post.feature
                                }, idx);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var tradly_home_EnablingEntrepreneurs = (EnablingEntrepreneurs);


/***/ }),

/***/ 15024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CheckoutPage_CheckoutPageLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var router = __webpack_require__(90387);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/Cart/CartItemBox/CartItemBox.jsx
/* eslint-disable react/prop-types */ 

var CartItemBox = function(param) {
    var cart = param.cart, cart_details = param.cart_details;
    var ref = (0,react.useState)(1), count = ref[0], setCount = ref[1];
    return cart_details ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: cart_details.map(function(cartItem) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " w-full border border-primary rounded-lg px-[24px] py-[16px] grid grid-cols-[100%] justify-between lg:grid-cols-[60%,35%] mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: " text-xs font-semibold leading-6 text-primary",
                                children: [
                                    cartItem.listing.stock,
                                    " products in stock"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: " text-base text-black font-semibold mt-[2px]",
                                children: cartItem.listing.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: " mt-[11px] text-secondary text-xs font-medium flex flex-wrap items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: " text-xs leading-6 font-medium text-secondary mr-2",
                                        children: cartItem.listing.list_price.currency
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-sm ",
                                        children: cartItem.listing.list_price.amount
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " w-full mt-6 lg:mt-0 flex items-center justify-around",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " min-w-[90px] h-[32px] border border-primary rounded-[2px] flex justify-between items-center ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return count > 1 && setCount(count - 1);
                                        },
                                        className: " w-[32px] h-[32px] bg-primary rounded-l-sm flex justify-center items-center text-xl leading-6 font-medium text-white",
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: " text-sm leading-4 font-medium text-[#4A4A4A] mx-3",
                                        children: count
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return setCount(count + 1);
                                        },
                                        className: "w-[32px] h-[32px] bg-primary rounded-r-sm flex justify-center items-center text-xl leading-6 font-medium text-white ",
                                        children: "+"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "w-[32px] h-[32px] bg-primary flex justify-center items-center text-xl leading-6 font-medium text-white rounded",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-6 w-6",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: "2",
                                            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }, cartItem.id);
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "border bg-[#3B3269] bg-opacity-[10%] shadow rounded-md p-4 w-full mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "animate-pulse flex space-x-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1 space-y-4 py-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded w-3/4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded w-5/6"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CartItemBox_CartItemBox = (CartItemBox);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/Cart/OrderSummary/ItemQuantity.jsx


var ItemQuantity = function(param) {
    var cart_details = param.cart_details;
    return cart_details.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " w-full min-h-[57px] bg-[#FFFFFF] border border-primary rounded-lg px-4 py-5 mb-3 ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: " text-sm leading-4 font-semibold text-[#4F4F4F] ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: item.quantity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2",
                        children: "X"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2",
                        children: item.listing.title
                    })
                ]
            })
        }, item.id);
    });
};
/* harmony default export */ var OrderSummary_ItemQuantity = (ItemQuantity);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/Cart/OrderSummary/OrderItems.jsx



var OrderItems = function(param) {
    var cart_details = param.cart_details;
    return cart_details.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full bg-[#FFFFFF] rounded-lg shadow-c-sm overflow-hidden flex mb-3 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " w-[100px] h-[100px] relative mr-3 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: item.listing.images[0],
                        layout: "fill",
                        objectFit: "cover",
                        alt: "Order Items",
                        priority: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " flex flex-col justify-around py-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: " text-base font-semibold text-black",
                                children: item.listing.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: " text-base font-medium text-secondary ",
                                    children: item.listing.location.country
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: " text-base font-medium text-secondary ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Quantity :"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: item.quantity
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }, item.id);
    });
};
/* harmony default export */ var OrderSummary_OrderItems = (OrderItems);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/Cart/OrderSummary/OrderSummary.jsx
/* eslint-disable react/prop-types */ 



var OrderSummary = function(param) {
    var cart = param.cart, cart_details = param.cart_details;
    var ref, ref1, ref2, ref3, ref4, ref5;
    return cart_details ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " w-full min-h-[200px] bg-[#FEFEFE] rounded-lg py-[26px] px-6 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-primary text-xl leading-6 font-medium mt-3",
                children: "Order Summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary_OrderItems, {
                    cart_details: cart_details
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary_ItemQuantity, {
                    cart_details: cart_details
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-base leading-6 font-semibold text-secondary flex justify-between items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Total"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: " flex flex-wrap items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-sm leading-6 font-medium text-secondary mr-2",
                                        children: (ref = cart.list_total) === null || ref === void 0 ? void 0 : ref.currency
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base leading-6 font-semibold text-gray-600",
                                        children: (ref1 = cart.list_total) === null || ref1 === void 0 ? void 0 : ref1.amount
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-base leading-6 font-semibold text-secondary flex justify-between items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Shipping"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: " flex flex-wrap items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-sm leading-6 font-medium text-secondary mr-2",
                                        children: (ref2 = cart.shipping_total) === null || ref2 === void 0 ? void 0 : ref2.currency
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base leading-6 font-semibold text-gray-600",
                                        children: (ref3 = cart.shipping_total) === null || ref3 === void 0 ? void 0 : ref3.amount
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-xl leading-6 font-semibold text-black flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Subtotal"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: " flex flex-wrap items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-sm leading-6 font-medium text-secondary mr-2",
                                        children: (ref4 = cart.grand_total) === null || ref4 === void 0 ? void 0 : ref4.currency
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xl leading-6 font-semibold text-black",
                                        children: (ref5 = cart.grand_total) === null || ref5 === void 0 ? void 0 : ref5.amount
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " border bg-[#3B3269] bg-opacity-[10%] shadow rounded-md p-4 w-full mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "animate-pulse flex space-x-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1 space-y-4 py-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded w-3/4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded w-5/6"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var OrderSummary_OrderSummary = (OrderSummary);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/Cart/PaymentMethods/PaymentMethod.jsx
/* eslint-disable react/prop-types */ 

var PaymentMethod = function(param) {
    var payment_methods = param.payment_methods, paymentMethod = param.paymentMethod, setPaymentMethod = param.setPaymentMethod;
    var selectPaymentMethod = function(method) {
        setPaymentMethod(method);
    };
    return payment_methods ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " w-full bg-[#FEFEFE] rounded-lg p-5 md:p-[31px] ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-primary text-xl leading-6 font-medium ",
                children: "Payment Method"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " mt-5 flex items-center flex-wrap",
                children: payment_methods.map(function(method) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id) !== method.id ? " min-w-[100px] h-5 px-2 md:px-6 py-4 border border-secondary flex items-center justify-between rounded-lg mr-3 mb-3  transition duration-700    hover:border-primary hover:text-primary" : " min-w-[100px] h-5 px-2 px-6 py-4 border   flex items-center justify-between   mr-3 mb-3  border-transparent bg-primary text-white rounded-md cursor-pointer  ring-2 ring-primary ring-offset-2 ",
                        onClick: function() {
                            return selectPaymentMethod(method);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " text-sm md:text-base font-semibold mr-3",
                                children: method.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "h-5 w-5 ml-3",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "2",
                                    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                            })
                        ]
                    }, method.id);
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " border bg-[#3B3269] bg-opacity-[10%] shadow rounded-md p-4 w-full mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "animate-pulse flex space-x-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1 space-y-4 py-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded w-3/4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "min-h-[16px] bg-[#3B3269] bg-opacity-[20%] rounded"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "min-h-[16px] bg-[#3B3269] bg-opacity-[20%] rounded w-5/6"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var PaymentMethods_PaymentMethod = (PaymentMethod);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/Cart/ShippingMethods/ShippingMethod.jsx
/* eslint-disable react/prop-types */ 

var ShippingMethod = function(param) {
    var shipping_methods = param.shipping_methods, shippingMethod = param.shippingMethod, setShippingMethod = param.setShippingMethod;
    var selectShippingMethod = function(method) {
        setShippingMethod(method);
    };
    return shipping_methods ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " w-full min-h-[100px] bg-[#FEFEFE] rounded-lg p-5 md:p-[31px] ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-primary text-xl leading-6 font-medium ",
                children: "Shipping Method"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " mt-5 flex items-center flex-wrap",
                children: shipping_methods.map(function(method) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.id) !== method.id ? " min-w-[100px] h-5 px-2  md:px-6 py-4 border border-secondary flex items-center justify-between rounded-lg mr-3 mb-3 transition duration-700   hover:border-primary hover:text-primary" : " min-w-[100px] h-5 px-2 md:px-6 py-4 border   flex items-center justify-between rounded-lg mr-3 mb-3    border-transparent bg-primary text-white  cursor-pointer  ring-2 ring-primary ring-offset-2 ",
                        onClick: function() {
                            return selectShippingMethod(method);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " text-sm md:text-base font-semibold mr-3",
                                children: method.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "h-5 w-5 ml-3",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "2",
                                    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                            })
                        ]
                    }, method.id);
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " border bg-[#3B3269] bg-opacity-[10%] shadow rounded-md p-4 w-full mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "animate-pulse flex space-x-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1 space-y-4 py-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded w-3/4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded w-5/6"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ShippingMethods_ShippingMethod = (ShippingMethod);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/Cart/AddressForm/AddressForm.jsx
/* eslint-disable react/prop-types */ 


var AddressForm = function(param) {
    var onSubmit = param.onSubmit, handleSubmit = param.handleSubmit, register = param.register, setShowShippingAddressForm = param.setShowShippingAddressForm;
    return /*#__PURE__*/ _jsxs("form", {
        className: " w-screen xs:w-[500px] mt-7 mb-7 bg-[#FEFEFE] rounded-lg p-[31px] relative",
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ _jsx("button", {
                className: " absolute top-0 right-0 mt-5 mr-5 text-primary ",
                onClick: function() {
                    return setShowShippingAddressForm(false);
                },
                children: /*#__PURE__*/ _jsx("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "h-6 w-6 ",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    children: /*#__PURE__*/ _jsx("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2",
                        d: "M6 18L18 6M6 6l12 12"
                    })
                })
            }),
            /*#__PURE__*/ _jsx("h2", {
                className: "text-2xl font-bold",
                children: "Shipping Address"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-8 w-full",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "grid grid-cols-1 gap-6",
                    children: [
                        /*#__PURE__*/ _jsxs("label", {
                            className: "block",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-gray-700",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ _jsx("input", _object_spread({
                                    type: "text",
                                    className: " mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 ",
                                    placeholder: ""
                                }, register("name", {
                                    required: true
                                })))
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("label", {
                            className: "block",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-gray-700",
                                    children: "Phone Number"
                                }),
                                /*#__PURE__*/ _jsx("input", _object_spread({
                                    type: "number",
                                    className: " mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 ",
                                    placeholder: ""
                                }, register("phone_number", {
                                    required: true
                                })))
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("label", {
                            className: "block",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-gray-700",
                                    children: "Address"
                                }),
                                /*#__PURE__*/ _jsx("input", _object_spread({
                                    type: "text",
                                    className: " mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 ",
                                    placeholder: "Address"
                                }, register("address_line_1", {
                                    required: true
                                })))
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-[100%] sm:grid-cols-[30%,30%,30%] sm:gap-[3.33%] ",
                            children: [
                                /*#__PURE__*/ _jsxs("label", {
                                    className: "block",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-gray-700",
                                            children: "Country"
                                        }),
                                        /*#__PURE__*/ _jsx("input", _object_spread({
                                            type: "text",
                                            className: " mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 ",
                                            placeholder: ""
                                        }, register("country", {
                                            required: true
                                        })))
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("label", {
                                    className: "block",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-gray-700",
                                            children: "State"
                                        }),
                                        /*#__PURE__*/ _jsx("input", _object_spread({
                                            type: "text",
                                            className: " mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 ",
                                            placeholder: ""
                                        }, register("state", {
                                            required: true
                                        })))
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("label", {
                                    className: "block",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-gray-700",
                                            children: "Postal Code"
                                        }),
                                        /*#__PURE__*/ _jsx("input", _object_spread({
                                            type: "number",
                                            className: " mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 ",
                                            placeholder: "123456"
                                        }, register("post_code", {
                                            required: true
                                        })))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-4 flex justify-center",
                children: /*#__PURE__*/ _jsx("button", {
                    className: " bg-primary rounded-lg px-4 py-2 text-white text-base font-semibold",
                    type: "submit",
                    children: "Save Address"
                })
            })
        ]
    });
};
/* harmony default export */ var AddressForm_AddressForm = ((/* unused pure expression or super */ null && (AddressForm)));

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/Cart/ShippingAddresses/ShippingAddresses.jsx
/* eslint-disable react/prop-types */ 

var ShippingAddresses = function(param) {
    var addresses = param.addresses, selectShippingAddress = param.selectShippingAddress, setSelectShippingAddress = param.setSelectShippingAddress;
    return /*#__PURE__*/ _jsx("div", {
        children: addresses === null || addresses === void 0 ? void 0 : addresses.map(function(location) {
            return /*#__PURE__*/ _jsxs("div", {
                onClick: function() {
                    return setSelectShippingAddress(location);
                },
                className: (selectShippingAddress === null || selectShippingAddress === void 0 ? void 0 : selectShippingAddress.id) === location.id ? "  mb-3  w-full  min-h-[81px] flex   justify-between  p-[16px] border   transition-all duration-1000	    border-transparent bg-primary text-white rounded-md cursor-pointer  ring-2 ring-primary ring-offset-2  " : " bg-white    w-full  min-h-[81px] flex   justify-between  p-[16px] text-secondary border  border-transparent  hover:border-primary rounded-md cursor-pointer mb-3 ",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex justify-start items-start",
                                children: /*#__PURE__*/ _jsx("svg", {
                                    width: "18",
                                    height: "22",
                                    viewBox: "0 0 18 22",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ _jsx("path", {
                                        d: "M17.4604 8.62982C17.32 7.16873 16.8036 5.7689 15.9616 4.56664C15.1195 3.36437 13.9805 2.40065 12.6554 1.76931C11.3303 1.13798 9.86425 0.860541 8.40008 0.964024C6.93592 1.06751 5.5235 1.54838 4.30037 2.35982C3.24957 3.06247 2.36742 3.98912 1.71731 5.07321C1.0672 6.1573 0.665264 7.37193 0.540369 8.62982C0.417852 9.87948 0.575043 11.1407 1.00054 12.3221C1.42604 13.5035 2.10917 14.5753 3.00037 15.4598L8.30037 20.7698C8.39333 20.8636 8.50393 20.9379 8.62579 20.9887C8.74765 21.0395 8.87836 21.0656 9.01037 21.0656C9.14238 21.0656 9.27309 21.0395 9.39495 20.9887C9.51681 20.9379 9.62741 20.8636 9.72037 20.7698L15.0004 15.4598C15.8916 14.5753 16.5747 13.5035 17.0002 12.3221C17.4257 11.1407 17.5829 9.87948 17.4604 8.62982ZM13.6004 14.0498L9.00037 18.6498L4.40037 14.0498C3.72246 13.3719 3.20317 12.5521 2.87984 11.6496C2.5565 10.747 2.43715 9.78402 2.53037 8.82982C2.62419 7.86092 2.93213 6.92498 3.43194 6.08966C3.93175 5.25435 4.61093 4.54053 5.42037 3.99982C6.48131 3.29506 7.72668 2.91912 9.00037 2.91912C10.2741 2.91912 11.5194 3.29506 12.5804 3.99982C13.3874 4.53844 14.065 5.2491 14.5647 6.08076C15.0644 6.91242 15.3737 7.84442 15.4704 8.80982C15.5666 9.76725 15.4488 10.7341 15.1254 11.6404C14.8019 12.5466 14.281 13.3697 13.6004 14.0498ZM9.00037 4.99982C8.11035 4.99982 7.24032 5.26374 6.5003 5.75821C5.76028 6.25267 5.18351 6.95548 4.84291 7.77775C4.50232 8.60001 4.4132 9.50481 4.58684 10.3777C4.76047 11.2506 5.18905 12.0525 5.81839 12.6818C6.44773 13.3111 7.24955 13.7397 8.12246 13.9134C8.99538 14.087 9.90018 13.9979 10.7224 13.6573C11.5447 13.3167 12.2475 12.7399 12.742 11.9999C13.2364 11.2599 13.5004 10.3898 13.5004 9.49982C13.4977 8.30716 13.0228 7.1641 12.1794 6.32076C11.3361 5.47742 10.193 5.00246 9.00037 4.99982ZM9.00037 11.9998C8.50592 11.9998 8.02257 11.8532 7.61144 11.5785C7.20032 11.3038 6.87989 10.9133 6.69067 10.4565C6.50145 9.99971 6.45194 9.49705 6.54841 9.01209C6.64487 8.52714 6.88297 8.08169 7.2326 7.73205C7.58223 7.38242 8.02769 7.14432 8.51264 7.04786C8.9976 6.95139 9.50026 7.0009 9.95708 7.19012C10.4139 7.37934 10.8043 7.69977 11.079 8.1109C11.3537 8.52202 11.5004 9.00537 11.5004 9.49982C11.5004 10.1629 11.237 10.7987 10.7681 11.2676C10.2993 11.7364 9.66341 11.9998 9.00037 11.9998Z",
                                        fill: "#121212"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "ml-[10px] ",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "text-base leading-4 font-semibold",
                                        children: location.country
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: " text-xs leading-4 font-medium w-[225px] mt-[2px]",
                                        children: location.formatted_address
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: " flex justify-center items-center float-right",
                        children: /*#__PURE__*/ _jsx("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "28",
                            height: "27",
                            viewBox: "0 0 28 27",
                            fill: (selectShippingAddress === null || selectShippingAddress === void 0 ? void 0 : selectShippingAddress.id) === location.id ? "white" : "var( --primary_color)",
                            children: /*#__PURE__*/ _jsx("path", {
                                d: "M26.1597 10.6734L16.8264 1.34003C16.0634 0.616021 15.0516 0.212402 13.9997 0.212402C12.9479 0.212402 11.9361 0.616021 11.1731 1.34003L1.83974 10.6734C1.09067 11.4234 0.669922 12.44 0.669922 13.5C0.669922 14.56 1.09067 15.5767 1.83974 16.3267L11.1731 25.66C11.9231 26.4091 12.9397 26.8298 13.9997 26.8298C15.0597 26.8298 16.0764 26.4091 16.8264 25.66L26.1597 16.3267C26.9088 15.5767 27.3295 14.56 27.3295 13.5C27.3295 12.44 26.9088 11.4234 26.1597 10.6734V10.6734ZM24.2797 14.4467L14.9464 23.78C14.8225 23.905 14.675 24.0042 14.5125 24.0719C14.35 24.1396 14.1758 24.1744 13.9997 24.1744C13.8237 24.1744 13.6494 24.1396 13.487 24.0719C13.3245 24.0042 13.177 23.905 13.0531 23.78L3.71974 14.4467C3.59476 14.3227 3.49557 14.1753 3.42788 14.0128C3.36019 13.8503 3.32534 13.676 3.32534 13.5C3.32534 13.324 3.36019 13.1497 3.42788 12.9873C3.49557 12.8248 3.59476 12.6773 3.71974 12.5534L13.0531 3.22003C13.177 3.09506 13.3245 2.99587 13.487 2.92818C13.6494 2.86048 13.8237 2.82563 13.9997 2.82563C14.1758 2.82563 14.35 2.86048 14.5125 2.92818C14.675 2.99587 14.8225 3.09506 14.9464 3.22003L24.2797 12.5534C24.4047 12.6773 24.5039 12.8248 24.5716 12.9873C24.6393 13.1497 24.6741 13.324 24.6741 13.5C24.6741 13.676 24.6393 13.8503 24.5716 14.0128C24.5039 14.1753 24.4047 14.3227 24.2797 14.4467ZM16.9464 9.8867C16.6953 9.63563 16.3548 9.49458 15.9997 9.49458C15.6447 9.49458 15.3041 9.63563 15.0531 9.8867C14.802 10.1378 14.6609 10.4783 14.6609 10.8334C14.6609 11.1884 14.802 11.529 15.0531 11.78L15.4531 12.1667H10.6664C10.3128 12.1667 9.97364 12.3072 9.72359 12.5572C9.47355 12.8073 9.33307 13.1464 9.33307 13.5V16.1667C9.33307 16.5203 9.47355 16.8595 9.72359 17.1095C9.97364 17.3596 10.3128 17.5 10.6664 17.5C11.02 17.5 11.3592 17.3596 11.6092 17.1095C11.8593 16.8595 11.9997 16.5203 11.9997 16.1667V14.8334H15.4531L15.0531 15.22C14.9281 15.344 14.8289 15.4914 14.7612 15.6539C14.6935 15.8164 14.6587 15.9907 14.6587 16.1667C14.6587 16.3427 14.6935 16.517 14.7612 16.6795C14.8289 16.8419 14.9281 16.9894 15.0531 17.1134C15.177 17.2383 15.3245 17.3375 15.487 17.4052C15.6494 17.4729 15.8237 17.5078 15.9997 17.5078C16.1758 17.5078 16.35 17.4729 16.5125 17.4052C16.675 17.3375 16.8225 17.2383 16.9464 17.1134L19.6131 14.4467C19.738 14.3227 19.8372 14.1753 19.9049 14.0128C19.9726 13.8503 20.0075 13.676 20.0075 13.5C20.0075 13.324 19.9726 13.1497 19.9049 12.9873C19.8372 12.8248 19.738 12.6773 19.6131 12.5534L16.9464 9.8867Z"
                            })
                        })
                    })
                ]
            }, Math.random());
        })
    });
};
/* harmony default export */ var ShippingAddresses_ShippingAddresses = ((/* unused pure expression or super */ null && (ShippingAddresses)));

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/Cart/StorageHubAddress/StorageHubAddresses.jsx
/* eslint-disable react/prop-types */ 

var StorageHubAddresses = function(param) {
    var addresses = param.addresses, selectStorageHubAddress = param.selectStorageHubAddress, setSelectStorageHubAddress = param.setSelectStorageHubAddress;
    return /*#__PURE__*/ _jsx("div", {
        children: addresses === null || addresses === void 0 ? void 0 : addresses.map(function(location) {
            return /*#__PURE__*/ _jsxs("div", {
                onClick: function() {
                    return setSelectStorageHubAddress(location);
                },
                className: (selectStorageHubAddress === null || selectStorageHubAddress === void 0 ? void 0 : selectStorageHubAddress.id) === location.id ? "  mb-3  w-full  min-h-[81px] flex   justify-between  p-[16px] border   transition-all duration-1000	    border-transparent bg-primary text-white rounded-md cursor-pointer  ring-2 ring-primary ring-offset-2  " : " bg-white    w-full  min-h-[81px] flex   justify-between  p-[16px] text-secondary border  border-transparent  hover:border-primary rounded-md cursor-pointer mb-3 ",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex justify-start items-start",
                                children: /*#__PURE__*/ _jsx("svg", {
                                    width: "18",
                                    height: "22",
                                    viewBox: "0 0 18 22",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ _jsx("path", {
                                        d: "M17.4604 8.62982C17.32 7.16873 16.8036 5.7689 15.9616 4.56664C15.1195 3.36437 13.9805 2.40065 12.6554 1.76931C11.3303 1.13798 9.86425 0.860541 8.40008 0.964024C6.93592 1.06751 5.5235 1.54838 4.30037 2.35982C3.24957 3.06247 2.36742 3.98912 1.71731 5.07321C1.0672 6.1573 0.665264 7.37193 0.540369 8.62982C0.417852 9.87948 0.575043 11.1407 1.00054 12.3221C1.42604 13.5035 2.10917 14.5753 3.00037 15.4598L8.30037 20.7698C8.39333 20.8636 8.50393 20.9379 8.62579 20.9887C8.74765 21.0395 8.87836 21.0656 9.01037 21.0656C9.14238 21.0656 9.27309 21.0395 9.39495 20.9887C9.51681 20.9379 9.62741 20.8636 9.72037 20.7698L15.0004 15.4598C15.8916 14.5753 16.5747 13.5035 17.0002 12.3221C17.4257 11.1407 17.5829 9.87948 17.4604 8.62982ZM13.6004 14.0498L9.00037 18.6498L4.40037 14.0498C3.72246 13.3719 3.20317 12.5521 2.87984 11.6496C2.5565 10.747 2.43715 9.78402 2.53037 8.82982C2.62419 7.86092 2.93213 6.92498 3.43194 6.08966C3.93175 5.25435 4.61093 4.54053 5.42037 3.99982C6.48131 3.29506 7.72668 2.91912 9.00037 2.91912C10.2741 2.91912 11.5194 3.29506 12.5804 3.99982C13.3874 4.53844 14.065 5.2491 14.5647 6.08076C15.0644 6.91242 15.3737 7.84442 15.4704 8.80982C15.5666 9.76725 15.4488 10.7341 15.1254 11.6404C14.8019 12.5466 14.281 13.3697 13.6004 14.0498ZM9.00037 4.99982C8.11035 4.99982 7.24032 5.26374 6.5003 5.75821C5.76028 6.25267 5.18351 6.95548 4.84291 7.77775C4.50232 8.60001 4.4132 9.50481 4.58684 10.3777C4.76047 11.2506 5.18905 12.0525 5.81839 12.6818C6.44773 13.3111 7.24955 13.7397 8.12246 13.9134C8.99538 14.087 9.90018 13.9979 10.7224 13.6573C11.5447 13.3167 12.2475 12.7399 12.742 11.9999C13.2364 11.2599 13.5004 10.3898 13.5004 9.49982C13.4977 8.30716 13.0228 7.1641 12.1794 6.32076C11.3361 5.47742 10.193 5.00246 9.00037 4.99982ZM9.00037 11.9998C8.50592 11.9998 8.02257 11.8532 7.61144 11.5785C7.20032 11.3038 6.87989 10.9133 6.69067 10.4565C6.50145 9.99971 6.45194 9.49705 6.54841 9.01209C6.64487 8.52714 6.88297 8.08169 7.2326 7.73205C7.58223 7.38242 8.02769 7.14432 8.51264 7.04786C8.9976 6.95139 9.50026 7.0009 9.95708 7.19012C10.4139 7.37934 10.8043 7.69977 11.079 8.1109C11.3537 8.52202 11.5004 9.00537 11.5004 9.49982C11.5004 10.1629 11.237 10.7987 10.7681 11.2676C10.2993 11.7364 9.66341 11.9998 9.00037 11.9998Z",
                                        fill: "#121212"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "ml-[10px] ",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "text-base leading-4 font-semibold",
                                        children: location.country
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: " text-xs leading-4 font-medium w-[225px] mt-[2px]",
                                        children: location.formatted_address
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: " flex justify-center items-center float-right",
                        children: /*#__PURE__*/ _jsx("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "28",
                            height: "27",
                            viewBox: "0 0 28 27",
                            fill: (selectStorageHubAddress === null || selectStorageHubAddress === void 0 ? void 0 : selectStorageHubAddress.id) === location.id ? "white" : "var( --primary_color)",
                            children: /*#__PURE__*/ _jsx("path", {
                                d: "M26.1597 10.6734L16.8264 1.34003C16.0634 0.616021 15.0516 0.212402 13.9997 0.212402C12.9479 0.212402 11.9361 0.616021 11.1731 1.34003L1.83974 10.6734C1.09067 11.4234 0.669922 12.44 0.669922 13.5C0.669922 14.56 1.09067 15.5767 1.83974 16.3267L11.1731 25.66C11.9231 26.4091 12.9397 26.8298 13.9997 26.8298C15.0597 26.8298 16.0764 26.4091 16.8264 25.66L26.1597 16.3267C26.9088 15.5767 27.3295 14.56 27.3295 13.5C27.3295 12.44 26.9088 11.4234 26.1597 10.6734V10.6734ZM24.2797 14.4467L14.9464 23.78C14.8225 23.905 14.675 24.0042 14.5125 24.0719C14.35 24.1396 14.1758 24.1744 13.9997 24.1744C13.8237 24.1744 13.6494 24.1396 13.487 24.0719C13.3245 24.0042 13.177 23.905 13.0531 23.78L3.71974 14.4467C3.59476 14.3227 3.49557 14.1753 3.42788 14.0128C3.36019 13.8503 3.32534 13.676 3.32534 13.5C3.32534 13.324 3.36019 13.1497 3.42788 12.9873C3.49557 12.8248 3.59476 12.6773 3.71974 12.5534L13.0531 3.22003C13.177 3.09506 13.3245 2.99587 13.487 2.92818C13.6494 2.86048 13.8237 2.82563 13.9997 2.82563C14.1758 2.82563 14.35 2.86048 14.5125 2.92818C14.675 2.99587 14.8225 3.09506 14.9464 3.22003L24.2797 12.5534C24.4047 12.6773 24.5039 12.8248 24.5716 12.9873C24.6393 13.1497 24.6741 13.324 24.6741 13.5C24.6741 13.676 24.6393 13.8503 24.5716 14.0128C24.5039 14.1753 24.4047 14.3227 24.2797 14.4467ZM16.9464 9.8867C16.6953 9.63563 16.3548 9.49458 15.9997 9.49458C15.6447 9.49458 15.3041 9.63563 15.0531 9.8867C14.802 10.1378 14.6609 10.4783 14.6609 10.8334C14.6609 11.1884 14.802 11.529 15.0531 11.78L15.4531 12.1667H10.6664C10.3128 12.1667 9.97364 12.3072 9.72359 12.5572C9.47355 12.8073 9.33307 13.1464 9.33307 13.5V16.1667C9.33307 16.5203 9.47355 16.8595 9.72359 17.1095C9.97364 17.3596 10.3128 17.5 10.6664 17.5C11.02 17.5 11.3592 17.3596 11.6092 17.1095C11.8593 16.8595 11.9997 16.5203 11.9997 16.1667V14.8334H15.4531L15.0531 15.22C14.9281 15.344 14.8289 15.4914 14.7612 15.6539C14.6935 15.8164 14.6587 15.9907 14.6587 16.1667C14.6587 16.3427 14.6935 16.517 14.7612 16.6795C14.8289 16.8419 14.9281 16.9894 15.0531 17.1134C15.177 17.2383 15.3245 17.3375 15.487 17.4052C15.6494 17.4729 15.8237 17.5078 15.9997 17.5078C16.1758 17.5078 16.35 17.4729 16.5125 17.4052C16.675 17.3375 16.8225 17.2383 16.9464 17.1134L19.6131 14.4467C19.738 14.3227 19.8372 14.1753 19.9049 14.0128C19.9726 13.8503 20.0075 13.676 20.0075 13.5C20.0075 13.324 19.9726 13.1497 19.9049 12.9873C19.8372 12.8248 19.738 12.6773 19.6131 12.5534L16.9464 9.8867Z"
                            })
                        })
                    })
                ]
            }, location.id);
        })
    });
};
/* harmony default export */ var StorageHubAddress_StorageHubAddresses = ((/* unused pure expression or super */ null && (StorageHubAddresses)));

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/data/CheckoutPageData.js
var CheckoutPageData = __webpack_require__(49965);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/CheckoutPageLayout.jsx












var CheckoutPageLayout = function() {
    var ref = (0,react.useState)(null), paymentMethod = ref[0], setPaymentMethod = ref[1];
    var ref1 = (0,react.useState)(null), shippingMethod = ref1[0], setShippingMethod = ref1[1];
    var ref2 = (0,react.useState)(false), showError = ref2[0], setShowError = ref2[1];
    var ref3 = (0,react.useState)(""), error_message = ref3[0], setError_message = ref3[1];
    var ref4 = (0,react.useState)(false), showShippingAddressForm = ref4[0], setShowShippingAddressForm = ref4[1];
    var ref5 = (0,react.useState)(null), selectShippingAddress = ref5[0], setSelectShippingAddress = ref5[1];
    var ref6 = (0,react.useState)(false), isNewAddress = ref6[0], setIsNewAddress = ref6[1];
    var ref7 = (0,react.useState)(null), selectStorageHubAddress = ref7[0], setSelectStorageHubAddress = ref7[1];
    var ref8 = (0,react.useState)(false), showSuccessMessage = ref8[0], setShowSuccessMessage = ref8[1];
    var isError = false;
    var errorMessage = "";
    var isFetching = false;
    var isCheckoutFetching = false;
    var isSuccess = false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " mx-auto w-full max-h-[490px] overflow-auto grid md:grid-cols-2 lg:grid-cols-3 gap-4 p-5 md:p-10 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " lg:col-span-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-[#FEFEFE] rounded-lg md:py-12 md:px-9 shadow-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemBox_CartItemBox, {
                                cart: CheckoutPageData.cart,
                                cart_details: CheckoutPageData.cart_details
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingMethods_ShippingMethod, {
                                shipping_methods: CheckoutPageData.shipping_methods,
                                shippingMethod: shippingMethod,
                                setShippingMethod: setShippingMethod
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethods_PaymentMethod, {
                                payment_methods: CheckoutPageData.payment_methods,
                                paymentMethod: paymentMethod,
                                setPaymentMethod: setPaymentMethod
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " shadow-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary_OrderSummary, {
                            cart: CheckoutPageData.cart,
                            cart_details: CheckoutPageData.cart_details
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: " w-5/6 bg-primary rounded-full py-[12px] text-center text-base text-white flex justify-center items-center font-semibold",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: " ",
                                    children: "Checkout"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CheckoutPage_CheckoutPageLayout = (CheckoutPageLayout);


/***/ }),

/***/ 49965:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _interopRequireDefault = (__webpack_require__(92648)/* ["default"] */ .Z);
var _beachHouseInterior1Jpg = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(63471));
var _image = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(25675));
var _airJordan1MidSeShoesHHltxpJpeg = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(99996));
module.exports = {
    cart: {
        id: 659,
        total: {
            amount: 180,
            currency: "AUD",
            formatted: "A$ 180"
        },
        list_total: {
            amount: 80,
            currency: "AUD",
            formatted: "A$ 80"
        },
        offer_total: {
            amount: 9.5,
            currency: "AUD",
            formatted: "A$ 9.5"
        },
        shipping_total: {
            amount: 100,
            currency: "AUD",
            formatted: "A$ 100"
        },
        grand_total: {
            amount: 180,
            currency: "AUD",
            formatted: "A$ 180"
        }
    },
    cart_details: [
        {
            id: 900,
            quantity: 1,
            quantity_total_price: {
                amount: 80,
                currency: "AUD",
                formatted: "A$ 80"
            },
            quantity_total_offer_price: {
                amount: 4500,
                currency: "AUD",
                formatted: "A$ 4500"
            },
            tax_total_offer_price: 0,
            listing: {
                id: 349,
                account_id: 126,
                list_price: {
                    amount: 80,
                    currency: "AUD",
                    formatted: "A$ 80"
                },
                category_id: [
                    280
                ],
                currency_id: 89,
                offer_percent: 5,
                stock: 61,
                shipping_charges: {
                    amount: 0,
                    currency: "AUD",
                    formatted: "A$ 0"
                },
                images: [
                    _airJordan1MidSeShoesHHltxpJpeg.default
                ],
                offer_price: {
                    amount: 9.5,
                    currency: "AUD",
                    formatted: "A$ 9.5"
                },
                location: {
                    city: "",
                    state: "",
                    country: "T\xfcrkiye",
                    locality: "",
                    postcode: "",
                    country_code: "tr",
                    formatted_address: "Mil, Ak\xe7akale, Şanlıurfa, G\xfcneydoğu Anadolu B\xf6lgesi, T\xfcrkiye"
                },
                type: "events",
                sold: false,
                active: true,
                status: 2,
                created_at: 1638876830,
                start_at: 1638876829,
                end_at: 1638876829,
                likes: 1,
                max_quantity: 10,
                account: {
                    id: 126,
                    name: "Missah Store",
                    location: {
                        city: "",
                        state: "Punjab",
                        country: "India",
                        locality: "Mattaur",
                        postcode: "160055",
                        country_code: "in",
                        formatted_address: "Mattaur, Mataur, Sahibzada Ajit Singh Nagar, Punjab, 160055, India"
                    },
                    unique_name: "",
                    description: "QWERTY",
                    total_followers: 4,
                    total_listings: 4,
                    images: [
                        "https://tradly-paas-sandbox.s3.amazonaws.com/images/tradlysocial/98658/62f44434-a608-4e67-ae23-e26fc9f5b8bd.PNG", 
                    ],
                    type: "accounts",
                    active: true,
                    status: 2,
                    following: false,
                    user: {
                        email_verified: false,
                        blocked: false,
                        id: "22800ba8-49eb-4a4b-be63-ec366fb25e9c",
                        first_name: "Deve",
                        last_name: "Saini",
                        profile_pic: "https://tradly-paas-sandbox.s3.amazonaws.com/images/tradlysocial/30974/b3240714-5368-4424-886a-d792f9031867.PNG"
                    },
                    category_id: []
                },
                distance: 0,
                in_cart: true,
                liked: false,
                title: "Jordan 1 Mid SE",
                description: "",
                coordinates: {
                    latitude: 36.8440172,
                    longitude: 38.7842206
                }
            }
        }, 
    ],
    payment_methods: [
        {
            id: 9,
            name: "Stripe",
            logo_path: "",
            max_amount: 100000,
            min_amount: 10,
            type: "stripe",
            channel: "sdk",
            default: true,
            order_by: 1,
            active: true
        },
        {
            id: 47,
            name: "PayU",
            logo_path: "",
            max_amount: 100,
            min_amount: 1,
            type: "payulatam",
            channel: "web",
            default: false,
            order_by: 1,
            active: true
        },
        {
            id: 1,
            name: "Cash on delivery",
            logo_path: "",
            max_amount: 1000.99,
            min_amount: 10,
            type: "cod",
            channel: "cod",
            default: false,
            order_by: 2,
            active: true
        }, 
    ],
    shipping_methods: [
        {
            id: 1,
            name: "Pick Up",
            logo_path: "",
            type: "pickup",
            default: false,
            active: true,
            order_by: 1
        },
        {
            id: 119,
            name: "Storage Hub",
            logo_path: "",
            type: "storage_hub",
            default: true,
            active: true,
            order_by: 4
        },
        {
            id: 10,
            name: "Delivery",
            logo_path: "",
            type: "delivery",
            default: false,
            active: true,
            order_by: 12
        }, 
    ]
};


/***/ }),

/***/ 10386:
/***/ (function(module) {

module.exports = JSON.parse('{"type":"TradlyTheme","typography":{"fontHeadlines":"Montserrat ","defaultTextColor":"#000000","boldText":"bold","semiboldText":"semibold","mediumText":"medium","normalText":"normal","decorationText":"none","caseText":"none","h1":{"size":"60px","letterSpacing":"wide","line-height":"73px"},"h2":{"size":"50px","letterSpacing":"wide","line-height":"61px"},"h3":{"size":"40px","letterSpacing":"wide","line-height":"49px"},"h4":{"size":"30px","letterSpacing":"normal","line-height":"37px"},"h5":{"size":"24px","letterSpacing":"normal","line-height":"29px"},"h6":{"size":"20px","letterSpacing":"normal","line-height":"24px"},"body-text":{"size":"16px","letterSpacing":"normal","line-height":"20px"},"caption-text":{"size":"14px","letterSpacing":"normal","line-height":"17px"},"tiny-text":{"size":"10px","letterSpacing":"normal","line-height":"12 px"}},"colors":{"primary":"#34d399","lightPrimary":"#DFFBF4","secondary":"#F6F9FF","darkSecondary":"#3C3352","neutralColors":{"black":"#121212","lightBlack":"#4F4F4F","grey":"#959393","lightGrey":"#E2E2E2","lightGrey-100":"#EEEEEE","white":"#FEFEFE"},"gradientColors":{"primary":"linear-gradient(0deg, #14B78E 0%, #2ADABF 100%)"}},"spacing":{"xsm":"4px","sm":"8px","md":"16px","lg":"24px","xl":"32px","2xl":"48px"},"shadows":{"sm":"0px 8px 28px rgba(0, 0, 0, 0.07)"},"border-radius":{"xsm":"4px","sm":"8px","md":"16px","lg":"24px","xl":"32px","2xl":"48px","3xl":"52px","full":"9999px"},"buttons":{"primary-button":{"weight":"normal","case":"none","letterSpacing":"normal","borderRadius":"none","horizontalPadding":30,"verticalPadding":12,"shadow":"none"},"buttonSecondary":{"weight":"normal","case":"none","letterSpacing":"normal","borderRadius":"none","borderStyle":"solid","horizontalPadding":30,"verticalPadding":12,"shadow":"none"}}}');

/***/ })

}]);